'use strict';

var circleProgressBars = require('./circleProgressBars');
var lineProgressBars = require('./lineProgressBars');

module.exports = function() {
    var $skills = $("#skills");
    var skillsTop = $skills.offset().top + 400;

    circleProgressBars.init();

    $(window).scroll(function(evt) {
        if ($(this).scrollTop() + $(this).height() > skillsTop) {
            lineProgressBars.animate();
        }

        if ($(this).scrollTop() + $(this).height() > skillsTop + 100) {
            circleProgressBars.animate();
        }
    });
};



// WEBPACK FOOTER //
// ./resources/js/components/skillsScroll.js